import useIsMounted from '../../../hooks/useIsMounted';
import { isNativeAppWebView } from '../native-apps-interface';
import getConfig from '../../../util/config';
import { isWebview } from '../../../util/device-detector';

/**
 * Checks whether the app is loaded in a native app webview.
 *
 * @param {boolean} [defaultValue] Default return value before all data is available for proper determination (i.e. Server-side rendering where there's no window object).
 * @returns {boolean}
 */
const useIsNativeWebView = defaultValue => {
  const config = getConfig();
  const isMounted = useIsMounted();

  if (isWebview(config.client.userAgent ?? '')) {
    return true;
  }

  return isMounted() && isNativeAppWebView(defaultValue);
};

export default useIsNativeWebView;
